/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Avatar } from '@mui/material'
import * as teamMembersClasses from 'pagesNew/TeamMembers/TeamMembersPlatformList/styles'
import { searchByGuideTitle_searchByGuideTitle_items as StudyGuide } from '__generatedTypes__/searchByGuideTitle'
import * as classes from 'pagesNew/OrginizeBlogPages/OrganizeCreateSuccessStory/Form/SuccessStoriesFieldArray/styles'

type Props = {
  studyGuide: StudyGuide
}

export const StudyGuideRenderItem: FC<Props> = ({ studyGuide }) => (
  <div css={teamMembersClasses.renderItem}>
    <div css={teamMembersClasses.block}>
      <div css={teamMembersClasses.avatar}>
        <Avatar
          src={studyGuide.author.getAvatar.photo || ''}
          css={teamMembersClasses.avatar}
          alt="Study guide author avatar"
        />
      </div>
      <Typography variant="body2" css={[teamMembersClasses.longText, classes.longText]}>
        {studyGuide.title}
      </Typography>
    </div>
  </div>
)
